import { usePageViewedEvent } from '~shared/hooks';
import { EVENTS } from '~shared/lib/analytics/src/constants';

export const useDeliveriesListViewed = () => {
  usePageViewedEvent({ event: EVENTS.DELIVERIES_LIST_VIEWED });
};
